module.exports = __webpack_public_path__ + "static/img/avatar_m.ea3714f5.png";